/* eslint-disable no-unused-vars */
import {React} from 'react';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';

function FeedbackContent() {

}



const FeedbackChannel = () => {
    //Create a responsive page layout  
    return (
      <div>
          <Navbar/>
          <NavbarLower/>
          <FeedbackContent/>
      </div> 
    );
};
    
export default FeedbackChannel;